import React from 'react';
import Menu from './components/Menu';
import About from './components/About';
import Membership from './components/Membership';
import JoinXaoDao from './components/JoinXaoDao';
import GovernanceProcess from './components/GovernanceProcess';
import Proposals from './components/Proposals';
import Grants from './components/Grants';
import Faq from './components/Faq';
import Contact from './components/Contact';
import StayConnectedFooter from './components/StayConnectedFooter';
import './index.css';
import NewChapter from './components/NewChapter';

function App() {
  return (
    <div className="min-h-screen bg-white">
      <Menu />
      <About />
      <Membership />
      <JoinXaoDao />
      <GovernanceProcess />
      <Proposals />
      <Grants />
      <Faq />
      <NewChapter />
      {/* <Contact /> */}
      <StayConnectedFooter />
    </div>
  );
}

export default App;